var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8 3.2C5.707 3.2 0 8.907 0 16s5.707 12.8 12.8 12.8c7.093 0 12.8-5.707 12.8-12.8S19.893 3.2 12.8 3.2zm0 24.533c-6.453 0-11.733-5.28-11.733-11.733S6.347 4.267 12.8 4.267 24.533 9.547 24.533 16 19.253 27.733 12.8 27.733z",
    fill: "#0B0C0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.467 19.04c-.267-.107-.587-.053-.693.213-1.173 2.293-3.467 3.68-5.973 3.68-2.56 0-4.8-1.387-5.973-3.68-.107-.267-.427-.373-.693-.213-.267.107-.373.427-.267.693C7.201 22.346 9.815 24 12.801 24c2.933 0 5.6-1.653 6.88-4.267.16-.267.053-.587-.213-.693zM10.133 13.333a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0zM18.667 13.333a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0z",
    fill: "#0B0C0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmile);
export default __webpack_public_path__ + "static/media/smile.92d19beab9ca802c92fcb0d825fbc705.svg";
export { ForwardRef as ReactComponent };